import type { TranslateOptions } from '../types';

/**
 * 翻译关键词建议
 */
export interface TranslateKeywordSuggest {
    /**
     * 原始词
     */
    original: string[];
    /**
     * 翻译推荐词
     */
    translation: string;
    /**
     * 推荐值
     */
    percentage: number;
}

/**
 * 根据翻译文本获取关键词翻译推荐列表
 */
export interface GetRecommendTranslateKeywordService {
    /**
     * 根据翻译文本获取关键词翻译推荐列表
     * @param taskId 任务ID
     * @returns 关键词翻译推荐列表
     */
    getRecommendTranslateKeyword: (taskId: string) => Promise<TranslateKeywordSuggest[]>;
}

export const GetRecommendTranslateKeywordService = Symbol('GetRecommendTranslateKeywordService');
